import React from 'react';
import { Container, Typography, Box, Paper, Grid, Card, CardContent, Button, Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const Suporte: React.FC = () => {
  return (
    <Box sx={{ minHeight: '80vh', py: 4, backgroundColor: '#f8f9fa' }}>
      <Container maxWidth="md">
        <Breadcrumbs sx={{ mb: 3 }}>
          <MuiLink component={Link} to="/" color="inherit" underline="hover">
            Início
          </MuiLink>
          <Typography color="text.primary">Suporte e Atendimento</Typography>
        </Breadcrumbs>

        <Paper elevation={0} sx={{ p: { xs: 3, md: 5 }, borderRadius: 3, border: '1px solid #e0e0e0', mb: 4 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: '12px',
                bgcolor: 'rgba(194, 53, 53, 0.1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#C23535',
              }}
            >
              <SupportAgentIcon sx={{ fontSize: 28 }} />
            </Box>
            <Box>
              <Typography variant="h4" component="h1" fontWeight={700} color="#202529">
                Central de Suporte
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Estamos aqui para ajudar com seu acesso, cadastro de empresa ou dúvidas gerais
              </Typography>
            </Box>
          </Box>

          <Typography paragraph sx={{ lineHeight: 1.8 }}>
            Precisa de auxílio para acessar sua conta com CPF/CNPJ, atualizar dados da sua empresa ou obter suporte técnico nos aplicativos móveis? Entre em contato diretamente com a equipe do IDEBRASIL pelos canais abaixo:
          </Typography>

          <Grid container spacing={3} sx={{ mt: 1 }}>
            <Grid item xs={12} sm={6}>
              <Card variant="outlined" sx={{ height: '100%', borderRadius: 2 }}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: '#25D366' }}>
                    <WhatsAppIcon sx={{ fontSize: 32 }} />
                    <Typography variant="h6" fontWeight={700} color="#202529">
                      WhatsApp Oficial
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                    Atendimento rápido para dúvidas de cadastro e suporte a alunos e empresários.
                  </Typography>
                  <Button
                    variant="contained"
                    component="a"
                    href="https://wa.me/5531991896725?text=Ol%C3%A1%2C%20preciso%20de%20ajuda%20no%20IDECONECTA"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ bgcolor: '#25D366', '&:hover': { bgcolor: '#1ebc59' } }}
                  >
                    Falar pelo WhatsApp
                  </Button>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Card variant="outlined" sx={{ height: '100%', borderRadius: 2 }}>
                <CardContent sx={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 1.5 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, color: '#C23535' }}>
                    <EmailIcon sx={{ fontSize: 32 }} />
                    <Typography variant="h6" fontWeight={700} color="#202529">
                      E-mail Institucional
                    </Typography>
                  </Box>
                  <Typography variant="body2" color="text.secondary" sx={{ flexGrow: 1 }}>
                    Envie solicitações formais, dúvidas sobre políticas ou relatórios.
                  </Typography>
                  <Button
                    variant="outlined"
                    component="a"
                    href="mailto:contato@idebrasil.com.br"
                    sx={{ color: '#C23535', borderColor: '#C23535' }}
                  >
                    contato@idebrasil.com.br
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Paper>

        <Paper elevation={0} sx={{ p: { xs: 3, md: 4 }, borderRadius: 3, border: '1px solid #e0e0e0' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
            <HelpOutlineIcon color="primary" />
            <Typography variant="h6" fontWeight={700} color="#202529">
              Dúvidas Frequentes
            </Typography>
          </Box>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 2 }}>
            Como acesso minha conta?
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Basta digitar seu CPF ou CNPJ cadastrado na tela de login. Não é necessário criar senha; o sistema valida automaticamente sua participação no ecossistema IDEBRASIL.
          </Typography>

          <Typography variant="subtitle2" fontWeight={700} sx={{ mt: 2 }}>
            Meu CPF não foi reconhecido. O que fazer?
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            Se você concluiu cursos no IDEBRASIL mas seu CPF ainda não consta na base ativa, fale com a secretaria do IDEBRASIL pelo WhatsApp acima para a liberação do seu registro.
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
};

export default Suporte;
